<template>
  <q-dialog
    :model-value="modelValue"
    @update:model-value="updateModel"
    persistent
  >
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="alert" color="primary" text-color="white" />
        <span class="q-ml-sm">{{ question }}</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancelar" color="primary" v-close-popup />
        <q-btn
          flat
          label="Confirmar"
          color="primary"
          @click="ok"
          v-close-popup
        />
      </q-card-actions>
    </q-card> </q-dialog
></template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({ modelValue: {}, question: { type: String } });
const emit = defineEmits(["ok", "update:model-value"]);
const updateModel = v => emit("update:model-value", v);
const ok = () => emit("ok");
</script>